/* unplugin-vue-components disabled */import { render } from "./WeetChapter.vue?vue&type=template&id=70d8882f&scoped=true&ts=true"
import script from "./WeetChapter.vue?vue&type=script&lang=ts"
export * from "./WeetChapter.vue?vue&type=script&lang=ts"

import "./WeetChapter.vue?vue&type=style&index=0&id=70d8882f&lang=scss"
import "./WeetChapter.vue?vue&type=style&index=1&id=70d8882f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d8882f"]])

export default __exports__